import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CompanyLicenceModel, ICPLAuthLicenceClient } from "./api/cplauthapi/CPLAuthAPI";

export interface ILicenceService {
  getCompanyLicence(): Promise<CompanyLicenceModel>;
}

@injectable()
export class LicenceService implements ILicenceService {
  @inject(SERVICE_TYPES.CPLAuthLicenceClient) cplAuthLicenceClient!: ICPLAuthLicenceClient;

  async getCompanyLicence(): Promise<CompanyLicenceModel> {
    return this.cplAuthLicenceClient.getLicenceStatus();
  }
}
